import { render, staticRenderFns } from "./PcRepartition.vue?vue&type=template&id=8f50462a&scoped=true"
import script from "./PcRepartition.vue?vue&type=script&lang=js"
export * from "./PcRepartition.vue?vue&type=script&lang=js"
import style0 from "./PcRepartition.vue?vue&type=style&index=0&id=8f50462a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f50462a",
  null
  
)

export default component.exports